module.exports = __webpack_public_path__ + "img/batteri-ladeniveau-forside_hvid70.7c6a1ee5.svg";